import { api } from "../../axios";

export const actions = {

    //Inspection IAR
    GetDeliveryExtension(context, data){
        return api.get(`PoDeliveryExtension/${data}`);
    },
    GetDeliveryExtensionByPo(context, data){
        return api.get(`PoDeliveryExtension/Po/${data}`);
    },
    GetPendingDeliveryExtensionByCampus(context, data){
        return api.get(`PoDeliveryExtension/Pending/${data}`);
    },
    GetApprovedDeliveryExtensionByCampus(context, data){
        return api.get(`PoDeliveryExtension/Approved/${data}`);
    },
    GetDisapprovedDeliveryExtensionByCampus(context, data){
        return api.get(`PoDeliveryExtension/DisApproved/${data}`);
    },
    CreateDeliveryExtension(context, data){
        return api.post(`PoDeliveryExtension/Create`, data);
    },
    DeleteDeliveryExtension(context, data){
        return api.delete(`PoDeliveryExtension/${data}`);
    },
    UpdateDeliveryExtension(context, data){
        return api.put(`PoDeliveryExtension/${data.id}`, data);
    },
    UpdateDeliveryExtensionLiquidatedDamages(context, data){
        return api.put(`PoDeliveryExtension/LiquidatedDamages/${data.id}/${data.status}`);
    },
    ApproveDeliveryExtension(context, data){
        return api.put(`PoDeliveryExtension/Approve/${data}`);
    },
    DisapproveDeliveryExtension(context, data){
        return api.put(`PoDeliveryExtension/Disapprove/${data}`);
    },
    ReturnDeliveryExtension(context, data){
        return api.put(`PoDeliveryExtension/Return/${data}`);
    },

}